"use strict";

exports.__esModule = true;
exports.overrideZendeskViewport = exports.overrideZendeskStyle = exports.authenticateZendesk = exports.toggleWidgetState = void 0;

var _jsonwebtoken = _interopRequireDefault(require("jsonwebtoken"));

var _utils = require("../../helpers/utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var toggleWidgetState = function toggleWidgetState(_ref) {
  var widgetState = _ref.widgetState,
      setWidgetState = _ref.setWidgetState;
  var state = widgetState === "hide" ? "show" : "hide";
  setWidgetState(state);
}; // hides header of zendesk component


exports.toggleWidgetState = toggleWidgetState;

var overrideZendeskStyle = function overrideZendeskStyle() {
  var zendeskFrame = document.getElementById("webWidget");
  var zendeskDOM = zendeskFrame.contentWindow.document;
  var css = "\n    .sc-htpNat { background-color: #FFF !important }\n    .sc-htpNat .IconButton-x15t1e-0:nth-last-of-type(-n+2) { display: none; }\n    .sc-htpNat > div > h1 { margin: 0 !important; }\n    .sc-htpNat { padding-bottom: 0 }\n    .sc-gzVnrw { padding-top: 0 }\n  ";
  var head = zendeskDOM.head || zendeskDOM.getElementsByTagName('head')[0];
  var style = zendeskDOM.createElement('style');
  head.appendChild(style);
  style.type = 'text/css';

  if (style.styleSheet) {
    // This is required for IE8 and below.
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(zendeskDOM.createTextNode(css));
  }
}; // forces zendesk to fill screen as if it was viewed on a small screen


exports.overrideZendeskStyle = overrideZendeskStyle;

var overrideZendeskViewport = function overrideZendeskViewport() {
  var css = "\n    #webWidget {\n      width: 750px;\n      max-width: 750px;\n      height: 1334px;\n      margin: 0 auto;\n      border-style: none;\n      border-color: inherit;\n      border-width: 0px;\n      -webkit-transform: scale(0.5);\n      -webkit-transform-origin: 0 0;\n      display: block;\n    }\n  ";
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  head.appendChild(style);
  style.type = 'text/css';

  if (style.styleSheet) {
    // This is required for IE8 and below.
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};

exports.overrideZendeskViewport = overrideZendeskViewport;

var authenticateZendesk = function authenticateZendesk(_ref2) {
  var zendeskSecret = _ref2.zendeskSecret,
      passedAccessToken = _ref2.passedAccessToken;
  var accessToken = passedAccessToken;
  var localAccessToken = _utils.inBrowser ? localStorage.getItem("access-token") : false;

  if (localAccessToken) {
    accessToken = localAccessToken;
  }

  if (accessToken) {
    var decodedToken = _jsonwebtoken["default"].decode(accessToken);

    var tokenUserInfo = decodedToken.userInfo;

    if (tokenUserInfo) {
      var name = tokenUserInfo.firstName + " " + tokenUserInfo.lastName;
      var currentDate = new Date();
      var payload = {
        name: name,
        email: tokenUserInfo.email,
        external_id: tokenUserInfo._id,
        iat: Math.floor(currentDate.getTime() / 1000)
      };

      var token = _jsonwebtoken["default"].sign(payload, zendeskSecret);

      return {
        name: name,
        token: token,
        email: tokenUserInfo.email
      };
    }
  }

  return false;
};

exports.authenticateZendesk = authenticateZendesk;